<template>
   <!--采购商指数-->
   <div id='hotCity' class='provide_container'></div>
</template>
<script>
import { http } from '@/http'
import echarts from 'echarts'
import 'echarts/chart/bar'
// import { option as hotCityOption } from '@/zjljChartsConfig/hotCityOption.js' // 配置项
// import {option as dataResponse} from '@/zjljChartsConfig/provideData.js' //临时数据
export default{
  props: {
    // productId: {
    //   type: Number,
    //   default: 0
    // },
    countyId: {
      type: Number,
      default: 0
    },
    legendFontSize: {
      type: Number,
      default: 18
    },
    fontSize: {
      type: Number,
      default: 20
    },
    fontWeight: {
      type: String,
      default: 'normal'
    },
    showCount: { // 显示的数据数量
      type: Number,
      default: 15
    },
    xlableTop: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      xAxisData: [],
      dataStore19: [],
      dataStore18: [],
      showIndexPre: 0,
      showIndexLast: 30,
      chartOption: {}
    }
  },
  methods: {
    // 获取地图数据
    getData (cb) {
      switch (this.$route.name) {
        case 'gdLitchi': {
          this.productId = this.productId || this.$route.params.product_id || 8048
          break
        }
        case 'sxhlg': {
          this.productId = this.productId || this.$route.params.product_id || 7832
          break
        }
        case 'mmlz': {
          this.productId = this.productId || this.$route.params.product_id || 8048
          break
        }
        case 'zjlj': {
          this.productId = this.productId || this.$route.params.product_id || 8016
          break
        }
        case 'mzyz': {
          this.productId = this.productId || this.$route.params.product_id || 8519
          break
        }
        default: {
          this.productId = this.productId || this.$route.params.product_id
        }
      }
      http.get('/canmou/tianji/product/hot_purchase_citys?product_id=' + this.productId + '&county_id=' + this.countyId).then(res => {
        this.dataResponse = res.data
        // 线数据
        this.dataStore19 = this.dataResponse.data.this_year_cnt
        this.dataStore18 = this.dataResponse.data.last_year_cnt
        // x轴数据
        this.xAxisDataStore = this.dataResponse.data.citys
        // 数据总数
        this.countAll = this.dataResponse.data.citys.length
        if (this.dataResponse.status === 0) {
          cb && cb()
        }
      })
    },
    // 初始化数据
    initOption () {
      this.chartOption = {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['今年采购商人数', '去年采购商人数'],
          textStyle: {
            fontSize: this.legendFontSize,
            color: '#fff'
          },
          x: '5%'
        },
        color: ['#274cd5', '#fe6d1b'],
        calculable: true,
        xAxis: [{
          splitLine: {
            show: false,

            color: '#141e34'
            // 隐藏内部线
          },
          type: 'category',
          data: [], // 外部配置数据
          axisLabel: {
            interval: 0,
            rotate: 45,
            textStyle: { // 刻度值的字体样式设置
              color: '#7591d8',
              fontSize: this.fontSize,
              fontWeight: this.fontWeight
            },
            margin: this.xlableTop
          }
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            interval: 0,
            rotate: 0,
            textStyle: { // 刻度值的字体样式设置
              color: '#7591d8',
              fontSize: this.fontSize,
              fontWeight: this.fontWeight
            },
            margin: 20
          }
        }],
        series: [{
          name: '2018',
          type: 'bar',
          data: [], // 外部配置数据
          barCategoryGap: 10, // 同个x坐标内的柱状图间距 px
          barGap: 0 // 几个柱状条的宽度

        }, {
          name: '2019',
          type: 'bar',
          data: [] // 外部配置数据
        }]
      }
      this.data18 = this.dataStore18.slice(0, this.showCount)
      this.data19 = this.dataStore19.slice(0, this.showCount)

      this.xAxisData = this.xAxisDataStore.slice(0, this.showCount)
      // x轴数据
      this.chartOption.xAxis[0].data = this.xAxisData
      // 线数据
      this.chartOption.series = [{
        name: '今年采购商人数',
        type: 'bar',
        data: this.data19,
        barCategoryGap: 10, // 同个x坐标内的柱状图间距 px
        barGap: 0 // 几个柱状条的宽度
      }, {
        name: '去年采购商人数',
        type: 'bar',
        data: this.data18
      }]

      this.lineChart.setOption(this.chartOption)
    },
    initPage () {
      if (!this.lineChart) {
        this.lineChart = echarts.init(document.getElementById('hotCity'))
      } else {
        this.lineChart.clear()
      }
      // 改变数据设置动效
      var that = this
      let changeLinePoint = () => {
        // if (that.showIndexLast > that.countAll) {
        //   that.showIndexPre = 0
        //   that.showIndexLast = that.showCount
        // }
        that.data18.length = 0
        that.data18.push(...that.dataStore18.slice(that.showIndexPre, that.showIndexLast))

        that.data19.length = 0
        that.data19.push(...that.dataStore19.slice(that.showIndexPre, that.showIndexLast))

        that.xAxisData.length = 0
        that.xAxisData.push(...that.xAxisDataStore.slice(that.showIndexPre, that.showIndexLast))
        that.lineChart.setOption(this.chartOption)
        // that.showIndexPre += that.showCount
        // that.showIndexLast += that.showCount
      }
      // 获取数据
      this.getData(() => {
      // 处理返回数据
        this.initOption()
        // 设置数据切换
        changeLinePoint()
      })
    }
  },
  watch: {
    // productId (val) {
    //   this.initPage()
    // }
    $route (to, from) {
      if (to.params && to.params.product_id !== from.params.product_id) {
        this.productId = to.params.product_id
        this.initPage()
      }
    }
  },
  mounted () {
    this.initPage()
  }
}

</script>
<style lang='less' scoped>
  .provide_container{
    width: 100%;
    height:100%;
    background:none;
    padding:10px;
  }
</style>
